import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {EnvironmentConfig} from '@environments/environment';
import {mergeDeep, TranslateLoader, TranslationObject} from '@ngx-translate/core';
import {forkJoin, Observable, of, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class CustomerTranslateLoader extends TranslateLoader {

  constructor(private http: HttpClient) {
    super();
  }

  getTranslation(language: string): Observable<TranslationObject> {
    const commonTranslations = this.http.get<TranslationObject>(`./assets/i18n/${language}.json`);

    if (!EnvironmentConfig.PortalSettings.customerTranslationsEnabled) {
      return commonTranslations;
    }

    const customer = EnvironmentConfig.PortalSettings.environment;
    const customerTranslations = this.http.get<TranslationObject>(`./assets/i18n/${customer}/${language}.json`).pipe(
      catchError((error: HttpErrorResponse) => error.status === 404 ? of({}) : throwError(() => error))
    );

    return forkJoin([commonTranslations, customerTranslations]).pipe(
      map(([common, customerSpecific]) => mergeDeep(common, customerSpecific) as TranslationObject)
    );
  }
}
